module.exports = __webpack_public_path__ + "img/qz-miniapp.27e9eb00.jpg";